import { AiChatDisplayMode } from '@insio/shared-types';
import { useAuth } from '@/features/auth';

/**
 * Resolves the user's chosen AI chat surface. Absent means bubble —
 * the mode is opt-in, matching the server-side default.
 */
export function useChatDisplayMode(): AiChatDisplayMode {
  const { user } = useAuth();
  return user?.currentPreferences?.chatDisplayMode ?? AiChatDisplayMode.BUBBLE;
}
